import { createBrowserRouter, RouteObject } from 'react-router';
import { paths } from '../shared/configs/paths';
import { HomePage } from './home';
import { MockPage } from './mock';

const ROUTES: RouteObject[] = [
  {
    path: paths.home,
    element: <HomePage />
  },
  {
    path: paths.mock,
    element: <MockPage />
  }
];

export const router = createBrowserRouter(ROUTES);
